export default __webpack_public_path__ + "ondemand/static/8b50f6e88/media/favicon-192.png";